import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import ChainedBackend from 'i18next-chained-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import en from './en/translation.json';
import ar from './ar/translation.json';
import { Environment } from 'configs/constants';

const bundledResources = {
  en: {
    translation: en,
  },
  ar: {
    translation: ar,
  },
};

export interface LanguageLabelsType {
  en: string;
  ar: string;
  [key: string]: string;
}

export const languageLabels: LanguageLabelsType = {
  en: 'English',
  ar: 'Arabic',
};

export const languageLabelsSel: LanguageLabelsType = {
  en: 'Select English',
  ar: 'Select Arabic',
};

export const locales: string[] = ['en', 'ar'];

export const enLocale = 'en';

export const LANGUAGE_STORAGE_KEY = 'accept-language';

const isLocalOrDevOrQA =
  import.meta.env.VITE_APP_MODE === Environment.LOCAL ||
  import.meta.env.VITE_APP_MODE === Environment.DEV ||
  import.meta.env.VITE_APP_MODE === Environment.QA ||
  import.meta.env.VITE_APP_MODE === Environment.STAGING;

export const i18n = i18next
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // load translations using chained backend with fallback
  .use(ChainedBackend)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    // Explicitly define supported languages to suppress console warnings about unsupported language codes
    supportedLngs: ['en', 'ar'],
    // Allow language variants (e.g., 'en-US', 'ar-SA') to be treated as supported languages
    // This prevents warnings when browser detects regional language variants
    nonExplicitSupportedLngs: true,
    // Load only the language code without region variants (e.g., 'en' instead of 'en-US')
    // This prevents warnings about missing translation files for regional variants
    load: 'languageOnly',
    backend: {
      backends: isLocalOrDevOrQA
        ? [resourcesToBackend(bundledResources)]
        : [HttpBackend, resourcesToBackend(bundledResources)],
      backendOptions: isLocalOrDevOrQA
        ? [{}]
        : [
            {
              loadPath: import.meta.env.VITE_APP_TRANSLATION_RESOURCE_PATH,
            },
            {},
          ],
      requestOptions: {
        // used for fetch, can also be a function (payload) => ({ method: 'GET' })
        mode: 'cors',
        credentials: 'same-origin',
        cache: 'default',
      },
    },
    // TODO: check mode for testing https://vitejs.dev/guide/env-and-mode
    // --mode staging
    debug: import.meta.env.MODE !== 'production' && import.meta.env.MODE !== 'test',

    interpolation: {
      format(value, format) {
        if (format === 'uppercase') return value.toUpperCase();
        if (format === 'bold') return String(value).bold();
        return value;
      },
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      // ...
      defaultTransParent: 'div', // a valid react element - required before react 16
      transEmptyNodeValue: '', // what to return for empty Trans
      transSupportBasicHtmlNodes: true, // allow <br/> and simple html elements in translations
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'], // don't convert to <1></1> if simple react elements
    },
  });
